import { IWPEvent } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IEventData = {
  allWpEvent: {
    nodes: IEvent[];
  };
};

export type IEvent = {
  eventsInfo: IWPEvent;
  uri: string;
  title: string;
  date: string;
  modified: string;
};

const useEventsData = () => {
  const { allWpEvent }: IEventData = useStaticQuery(graphql`
    {
      allWpEvent(sort: { date: DESC }) {
        nodes {
          eventsInfo {
            endDate
            datepicker
            datepickerEnd
            image {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                    quality: 100
                  )
                }
              }
            }
            location
            startTime
            tag
            contentTitle
            wysiwygContent
            infoBox {
              infoTitle
              infoText
            }
            linkBlock {
              linkBlockTitle
              linkBlockLink {
                url
                target
                title
              }
            }
            videoUrl
          }
          uri
          title
          date(locale: "SV", formatString: "DD MMMM YYYY")
          modified(formatString: "D MMMM YYYY")
        }
      }
    }
  `);
  return allWpEvent.nodes;
};
export default useEventsData;
